import { AppBar, Toolbar } from '@mui/material';
import { FC } from 'react';
import { EnaraLogo } from '../../../assets/icons';
import styles from './EnaraHeader.module.css';

const EnaraHeader: FC = () => {
  return (
    <AppBar color='transparent' elevation={0} position='relative'>
      <Toolbar className={styles.header}>
        <img src={EnaraLogo} alt='app-icon' height={16} />
      </Toolbar>
    </AppBar>
  );
};

export default EnaraHeader;
